import { createComponent } from '@carvana/merch-components';
import React from 'react';
import { modalZIndex } from '~/constants/srp/zIndex';

export const Overlay = createComponent('div', {
  className: 'fixed inset-0 bg-blue-7 bg-opacity-60',
  style: { zIndex: modalZIndex - 1 }
});

export const Wrapper = createComponent('div', {
  className:
    'pointer-events-none fixed inset-0 flex items-end justify-center m:items-center m:pr-[var(--scrollbar-width)]',
  style: { zIndex: modalZIndex }
});

export const Modal = createComponent('div', {
  className: 'pointer-events-auto rounded-t-xl bg-white m:rounded'
});

export const Header = createComponent('div', {
  className: 'flex justify-end p-8'
});

export const DismissButton = createComponent<
  React.HTMLProps<HTMLButtonElement>
>('button', {
  className:
    'flex h-32 w-32 items-center justify-center border-0 bg-transparent p-0'
});

export const Content = createComponent('div', {
  className: 'grid gap-24 px-24 pb-24 m:px-[140px] m:pb-44'
});

export const TextWrapper = createComponent('div', {
  className: 'grid grid-cols-[auto_1fr] grid-rows-2 items-center gap-8'
});
